import React, { useRef, useCallback } from 'react';
import styled from 'styled-components/macro';

import useFlavorStore from '../../../../../common/store/useFlavorStore';
import Container from '../../Container';
import { getVh } from '../../utils';
import useParallax from '../../useParallax';
import useAnimation from './useAnimation';

const Uno = styled.img`
  aspect-ratio: 256/204;
  width: 320rem;
  height: auto;

  transform: rotate(-20deg);
`;

const Dos = styled.img`
  aspect-ratio: 256/293;
  width: 140rem;
  height: auto;

  transform: rotate(45deg);
`;

const Watermelon = () => {
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  const ref = {
    figure: {
      uno: useRef<HTMLElement>(null),
      dos: useRef<HTMLElement>(null)
    },
    img: {
      uno: useRef<HTMLImageElement>(null),
      dos: useRef<HTMLImageElement>(null)
    }
  }

  const top = {
    uno: getVh("flavor", 0.5),
    dos: getVh("flavor", 0.25)
  }

  useAnimation(flavor === "watermelon", [ref.figure.uno, ref.figure.dos]);

  useParallax(ref.img.uno, top.uno, 200);
  useParallax(ref.img.dos, top.dos, 100);

  return (
    <>
      <Container
        ref={ref.figure.uno}
        top={top.uno}
        style={{ left: "60vw" }}
      >
        <Uno
          ref={ref.img.uno}
          src="/static/images/fill/watermelon/1.png"
        />
      </Container>

      <Container
        ref={ref.figure.dos}
        top={top.dos}
        style={{ left: "70vw" }}
      >
        <Dos
          ref={ref.img.dos}
          src="/static/images/fill/watermelon/2.png"
        />
      </Container>
    </>
  );
}

export default Watermelon;